import { useForm, UseFormWatch } from "react-hook-form";
import { selectorTransversal } from "../../../../dtos/selector";
import { Suspense, useEffect, useMemo, useState } from "react";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { Box, Dialog, DialogContent, DialogTitle, Grid2 } from "@mui/material";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import Tabla from "../../../../components/ui/materialui/tablaServerSelector";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import FilterListIcon from '@mui/icons-material/FilterList';
import { config } from '../../../../utils/config';
import UseTablaDesarrolloColumns from "../utils/columns";
import { operacion } from "../../../detalleMutuo/models/operacion";
import { useOperacion } from "../../../detalleMutuo/hooks/useOperacion";
import { BuscadorTablasForm } from "../models/buscadorTablasForm";
import AddIcon from '@mui/icons-material/Add';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { TablaBasicFilter } from "../../../../utils/tableBasicFilter";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

interface IProps {
    watchParentForm?: UseFormWatch<operacion>;
    clickLupaCuotaMaxima: boolean;
    clickLupaCuotaMinima: boolean;
    setTablaSeleccionada: React.Dispatch<React.SetStateAction<any | undefined>>;
    onHide: () => void;
    isActionable: boolean;
    onCreate: () => void;
    onImport: () => void;
    onUpdate: (id?: number | null) => void;
    onDelete: (id?: number | null) => void;
    onDetalle: (id?: number | null) => void;
    onRestart: () => void;
    key: number;
}

const FormularioBusquedaTablaDesarrollo: React.FC<IProps> = (props) => {

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
        watch,
    } = useForm<BuscadorTablasForm>()
    
    const { COLUMNS } = UseTablaDesarrolloColumns({
        isActionable: props.isActionable,
        updateTabla: props.onUpdate,
        deleteTabla: props.onDelete,
        detalleTabla: props.onDetalle
    });
    const columns = useMemo(() => COLUMNS, [control]);
    const urlApiTablasDesarrollo = `${config.URL_API_SISCRED}siscred-api-mutuo/v1/tablas-desarrollo/filtrar`;

    const controlTabla = useDataFetch(
        urlApiTablasDesarrollo,
        new URLSearchParams(),
        true,
    )

    const [filtros, setFiltros] = useState<TablaBasicFilter>({
        sort: null,
        order: null,
        take: null,
        page: null,
        search: null
    })

    const { initSelectorBaseTasas, listarSelectores, selectorBaseTasas, tipoProductos } = useOperacion();
    const [toggleFilterButtonClicked, setToggleFilterButtonClicked] = useState<boolean>(false);
    const onSubmit = (data: BuscadorTablasForm) => filtrar(data)

    function filtrar(data: BuscadorTablasForm) {

        if (data.tipoProducto) {
            controlTabla.manejarCambiosFiltros(
                'filters.tipo_producto',
                data.tipoProducto.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.tipo_producto',
                '',
            )
        }

        if (data.plazoCredito || data.plazoCredito === 0) {
            controlTabla.manejarCambiosFiltros(
                'filters.plazo_credito',
                data.plazoCredito.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.plazo_credito',
                ''
            )
        }

        if (data.periodoGraciaCapital || data.periodoGraciaCapital === 0) {
            controlTabla.manejarCambiosFiltros(
                'filters.periodo_gracia_capital',
                data.periodoGraciaCapital.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.periodo_gracia_capital',
                '',
            )
        }

        if (data.periodoGraciaCapitalIntereses || data.periodoGraciaCapitalIntereses === 0) {
            controlTabla.manejarCambiosFiltros(
                'filters.periodo_gracia_capital_intereses',
                data.periodoGraciaCapitalIntereses.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.periodo_gracia_capital_intereses',
                ''
            )
        }

        if (data.baseTasa) {
            controlTabla.manejarCambiosFiltros(
                'filters.base_tasa',
                data.baseTasa.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.base_tasa',
                '',
            )
        }

        if (data.tasa) {
            controlTabla.manejarCambiosFiltros(
                'filters.tasa',
                data.tasa.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.tasa',
                ''
            )
        }

        if (data.nombreTabla) {
            controlTabla.manejarCambiosFiltros(
                'filters.nombre_tabla',
                data.nombreTabla.toString(),
            )
        } else {
            controlTabla.manejarCambiosFiltros('filters.nombre_tabla', '')
        }

        controlTabla.fetchData()
        //props.onRestart();
    }

    const dataParentForm = props.watchParentForm != null ? props.watchParentForm() : null;

    const tableHeader = props.isActionable ?
        <PermissionGuard permissions={[TipoFuncionalidad.Maestros_editar]}>
            <Grid2 container spacing={1} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                <MButton
                    variant='contained'
                    color='primary'
                    onClick={props.onCreate}
                    startIcon={<AddIcon />}
                >
                    Nueva
                </MButton>
                <MButton
                    variant='contained'
                    color='primary'
                    onClick={props.onImport}
                    startIcon={<NoteAddIcon />}
                >
                    Importar
                </MButton>
            </Grid2>
        </PermissionGuard>
        : <></>

    useEffect(() => {
        if (dataParentForm) {
            setValue("tipoProducto", dataParentForm.tipoProducto);

            if (props.clickLupaCuotaMinima) {
                setValue("plazoCredito", dataParentForm.plazoMaximo!);
            }
            else {
                setValue("plazoCredito", dataParentForm.plazoMinimo!);
            }

            setValue("periodoGraciaCapital", dataParentForm.mesesGraciasK);
            setValue("periodoGraciaCapitalIntereses", dataParentForm.mesesGraciaKI);
            setValue("tasa", dataParentForm.tasaEmision);
            setValue("nombreTabla", "");

            const buscadorTablasForm: BuscadorTablasForm = {
                tipoProducto: dataParentForm.tipoProducto,
                plazoCredito: props.clickLupaCuotaMinima ? dataParentForm.plazoMaximo! : dataParentForm.plazoMinimo!,
                periodoGraciaCapital: dataParentForm.mesesGraciasK,
                periodoGraciaCapitalIntereses: dataParentForm.mesesGraciaKI,
                tasa: dataParentForm.tasaEmision,
                baseTasa: "",
                nombreTabla: "",
            }

            filtrar(buscadorTablasForm);
        }

    }, []);

    useEffect(() => {
        initSelectorBaseTasas();
        listarSelectores();
    }, []);

    useEffect(() => {
        controlTabla.fetchData();
        props.onRestart();
    }, [props.key])

    return (
        <Suspense>
            <CustomAccordion
                title='Filtros'
                expandedDefault
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid2 container spacing={2} sx={{ mt: 2 }}>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputSelect
                                label="Tipo producto"
                                name={'tipoProducto'}
                                control={control}
                                options={tipoProductos}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputNumber
                                label="Plazo crédito"
                                name="plazoCredito"
                                control={control}
                                maxValue={999}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputNumber
                                label="Período de gracia K"
                                name="periodoGraciaCapital"
                                control={control}
                                maxValue={999}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputNumber
                                label="Período de gracia K + I"
                                name="periodoGraciaCapitalIntereses"
                                control={control}
                                maxValue={999}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputNumber
                                label="Tasa"
                                name="tasa"
                                control={control}
                                maxValue={100}
                                decimales={2}
                                suffix="%"
                                disabled={!props.isActionable}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputSelect
                                label="Base tasa"
                                name="baseTasa"
                                control={control}
                                options={selectorBaseTasas}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 2 }}>
                            <InputText
                                label="Nombre tabla"
                                name="nombreTabla"
                                control={control}
                            />
                        </Grid2>
                        <Grid2 size={10} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <MButton
                                type="submit"
                                variant="contained"
                                color="primary"
                                startIcon={<FilterListIcon />}
                                onClick={() => setToggleFilterButtonClicked(!toggleFilterButtonClicked)}>

                                Filtrar
                            </MButton>
                        </Grid2>
                    </Grid2>
                </form>
            </CustomAccordion>

            <Box sx={{ mt: 4 }}>
                <Suspense>
                    <Tabla
                        columns={columns}
                        control={controlTabla}
                        url={urlApiTablasDesarrollo}
                        callApi={false}
                        setFilaSeleccionada={props.setTablaSeleccionada}
                        onHide={props.onHide}
                        toggleFilterButtonClicked={toggleFilterButtonClicked}
                        esMultiple={false}
                        titulo={<TableHeader
                            searchFilter={filtros?.search}
                            setFiltros={setFiltros}
                            button={tableHeader}
                            control={props.isActionable ? controlTabla : undefined}
                            buttonExport={
                                props.isActionable ?
                                    <>
                                        <MButton
                                            type="button"
                                            variant="outlined"
                                            onClick={() => exportExcel(controlTabla.data, columns, "TABLA_DESARROLLO")}
                                            startIcon={<SummarizeTwoToneIcon />}
                                        >
                                            Exportar
                                        </MButton>
                                    </> : <></>
                            }
                        />}
                        esCheckDisponible={!props.isActionable}
                    />
                </Suspense>
            </Box>
        </Suspense>
    )
}

export default FormularioBusquedaTablaDesarrollo;